import React from 'react';
import { useStyleSwitch } from '../../../hooks/useStyleSwitch';
import type { ChipTextProps, ChipState } from '../Chip.types';
import { textStyles as textStylesConfig } from '../styles';
import { BodyText } from '../../Text';

export const ChipText = ({
  state,
  children,
  maxFontSizeMultiplier,
}: ChipTextProps) => {
  const useTextStyles = useStyleSwitch<ChipState>('state', textStylesConfig);
  const textStyles = useTextStyles(state);

  return (
    <BodyText
      size={4}
      style={textStyles}
      maxFontSizeMultiplier={maxFontSizeMultiplier}
    >
      {children}
    </BodyText>
  );
};
